import Avatar from '@components/common/avatar'
import { StudentProps } from '@lib/types/classroom'
import { Mail, Phone } from 'react-feather'

type StudentDetailsCardProps = {
  studentDetails: StudentProps
}

export const StudentDetailsCard = ({
  studentDetails,
}: StudentDetailsCardProps) => (
  <div className="flex flex-col p-4 overflow-hidden rounded-lg bg-grey-100">
    <p className="mb-3 font-600">Student details</p>
    <div className="flex items-center space-x-5">
      <div className="flex items-center">
        <Avatar image={studentDetails?.avatar} isNotCurrentUser />
        <span className="ml-3 font-500">{studentDetails?.name}</span>
      </div>
      <p>{studentDetails?.grade}</p>
    </div>
    <div className="flex flex-wrap ml-1">
      <a
        href={`tel:${studentDetails?.phone}`}
        className="flex items-center mt-3 mr-3 group"
      >
        <span className="flex items-center justify-center w-6 h-6 bg-orange-200 rounded-full">
          <Phone className="text-orange" size={14} />
        </span>
        <span className="ml-2 text-grey group-hover:underline group-hover:text-orange">
          {studentDetails?.phone}
        </span>
      </a>
      <a
        href={`mailto:${studentDetails?.email}`}
        className="flex items-center mt-3 group"
      >
        <span className="flex items-center justify-center w-6 h-6 bg-orange-200 rounded-full">
          <Mail className="text-orange" size={14} />
        </span>
        <span className="ml-2 text-grey group-hover:underline group-hover:text-orange">
          {studentDetails?.email}
        </span>
      </a>
    </div>
  </div>
)
